// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hot-home .hot-box[data-v-6dc6660f]{margin-top:4px}.hot-home .hot-box .hot-title[data-v-6dc6660f]{font-size:10px}.hot-home .hot-box .hot-title a[data-v-6dc6660f]{text-decoration:none;color:#000}.hot-home .hot-box .hot-title a[data-v-6dc6660f]:hover{color:#50bae7}.hot-home .hot-approve[data-v-6dc6660f]{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between}.hot-home .hot-approve .decorate[data-v-6dc6660f]{width:30%;font-size:12px;color:#99b0c7}", ""]);
// Exports
module.exports = exports;
